@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.profileCard {
  margin-bottom: $spacing-xxl;
  border-radius: 12px !important;
}

.toggleButton {
  width: 100%;
}

.statusToggle {
  margin-bottom: 0;
}

.gearItemsList {
  margin-bottom: $spacing-s;
  border-radius: 12px !important;
}
